/**
 * @method convertDateToYYMMDDFormat
 * @description Converts a Date object to the YY-MM-DD format.
 * @param date - The Date object to be converted.
 * @returns The date in the YY-MM-DD format.
 */
export const convertDateToYYMMDDFormat = (date: Date | null): string => {
  let yyyymmdd = '';
  if (date) {
    const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
    const curDate = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
    const year = date.getFullYear();
    yyyymmdd = `${year}-${month}-${curDate}`;
  }
  return yyyymmdd;
};
